module.exports = __webpack_public_path__ + "img/ve.veede15c2.svg";